<template>
  <feedback :message="message" :feedback-class="feedbackClass" />
</template>

<script>
import Feedback from './feedback'

export default {
  components: { Feedback },
  props: {
    message: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      feedbackClass: 'feedback--error'
    }
  }
}
</script>
